<script lang="ts">
  import { LIMITS } from '../model/types';

  interface Props {
    value: string;
    /** Accessible name of the edit button and the input, e.g. "Rename Pain". */
    label: string;
    onsubmit: (value: string) => void;
    class?: string;
  }

  let { value, label, onsubmit, class: className }: Props = $props();

  let editing = $state(false);
  let draft = $state('');
  /** Return focus to the (re-created) button after editing. */
  let refocus = false;

  function start() {
    draft = value;
    editing = true;
  }

  function focusInput(element: HTMLInputElement) {
    element.focus();
    element.select();
  }

  function stop(commit: boolean, restoreFocus: boolean) {
    if (!editing) return;
    editing = false;
    refocus = restoreFocus;
    // Blank names are rejected by the model; reverting is the expected outcome.
    if (commit && draft.trim() !== '' && draft !== value) onsubmit(draft);
  }

  function focusOnMount(element: HTMLElement) {
    if (!refocus) return;
    refocus = false;
    element.focus();
  }
</script>

{#if editing}
  <input
    {@attach focusInput}
    bind:value={draft}
    aria-label={label}
    maxlength={LIMITS.name}
    class={[
      'h-8 w-full min-w-0 rounded-md border border-line-strong/70 bg-surface px-2 text-base text-ink sm:text-sm',
      className,
    ]}
    onkeydown={(event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        stop(true, true);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        stop(false, true);
      }
    }}
    onblur={() => {
      stop(true, false);
    }}
  />
{:else}
  <button
    {@attach focusOnMount}
    type="button"
    aria-label={label}
    class={[
      'min-w-0 cursor-text rounded-md px-1 text-left break-words decoration-line-strong decoration-dashed underline-offset-4 hover:bg-surface-2 hover:underline',
      className,
    ]}
    onclick={start}
  >
    {value}
  </button>
{/if}
